// Operaciones · Reembolsos — desglose de un cobro
//
// Quién iba en la orden, cuánto vale su cupo y si ESTE pago se lo entregó. Es la
// evidencia detrás del "a devolver": el backend ya mandaba `detalleItems` en cada
// candidato, pero la tabla no lo mostraba y el número quedaba sin respaldo, justo
// para quien tiene que teclear el reembolso en Transbank.
//
// Vive aparte de Reembolsos.jsx a propósito: no depende del cliente de API, así que
// se puede montar en un test sin arrastrar axios ni Amplify.

import React from 'react';
import { Table, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { limpiarNombre } from '../../../../utils/formatters';

const { Text } = Typography;

const pesos = (n) => `$${Number(n || 0).toLocaleString('es-CL')}`;

export default function DetalleCobro({ row }) {
  const items = row?.detalleItems || [];

  if (!items.length) {
    return (
      <Text type="secondary">
        Esta orden no tiene ítems registrados, así que no se puede desglosar el cobro.
        Revisar la orden {row?.codigo} directamente antes de devolver nada.
      </Text>
    );
  }

  const columnas = [
    {
      title: 'Ítem', dataIndex: 'tipo', width: 110,
      render: (t) => <Tag color={t === 'matricula' ? 'purple' : 'blue'}>{t === 'matricula' ? 'Matrícula' : 'Taller'}</Tag>
    },
    { title: 'Inscrito', dataIndex: 'inscrito', render: (n) => limpiarNombre(n) || '—' },
    { title: 'RUT', dataIndex: 'rut', width: 120, render: (r) => r || '—' },
    { title: 'Monto', dataIndex: 'monto', width: 110, align: 'right', render: (m) => pesos(m) },
    {
      title: '¿Lo entregó este pago?', dataIndex: 'servidoPorEstePago', width: 190, align: 'center',
      render: (ok) => ok
        ? <Tag color="green">Sí · no se devuelve</Tag>
        : <Tag color="red">No · a devolver</Tag>
    },
  ];

  return (
    <div style={{ padding: '4px 0 8px' }}>
      <Table
        rowKey="idx" size="small" pagination={false}
        columns={columnas} dataSource={items}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={3}>
              <Text strong>Cobrado {pesos(row.monto)}</Text>
              <Text type="secondary">{'  =  '}entregado {pesos(row.montoServido)}{'  +  '}</Text>
              <Text strong type="danger">a devolver {pesos(row.montoAReembolsar)}</Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={3} colSpan={2} align="right">
              <Text code>{row.auth || 'sin auth'}</Text>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      {(row.motivo || row.tipoRevision) && (
        <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
          Motivo de la revisión: {row.motivo || row.tipoRevision}
        </Text>
      )}
      {row.reembolso?.notas && (
        <Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
          Notas: {row.reembolso.notas}
          {row.reembolso.marcadoPor ? ` — ${row.reembolso.marcadoPor}` : ''}
          {row.reembolso.marcadoEn ? ` (${dayjs(row.reembolso.marcadoEn).format('DD/MM/YYYY HH:mm')})` : ''}
        </Text>
      )}
    </div>
  );
}
